import {Lang} from 'yougile-lang'

export const checkColumn = (name: string, fileNames: string[]) => {
  if (fileNames.includes(name)) {
    return {
      text: Lang.msg.importFromFile.detected,
      className: 'text-success-old'
    }
  }

  return {
    text: Lang.msg.importFromFile.notDetected,
    className: 'text-error-old'
  }
}
